
import { put, call, takeEvery, select, takeLatest } from 'redux-saga/effects';
import * as actions from './actions';
import { Endpoints } from 'services/api';
import errorHandler from 'common/errorHandler';

const getTenant = (state) => state.userLogin.tenant;

function* getEventUser(api, tenantId, eventId, userId) {
    try {
        let result = yield call([api, api.get], `${Endpoints.events}/api/v1/events/${eventId}/users/${userId}`, { tenantid: tenantId });
        return result.data;
    }
    catch (error) {
        if (error.isAxiosError) {
            if (error.response && error.response.status === 404) {
                return null;
            }
        }
        throw error;
    }
}

export function* getEventUserRequest(api, { eventId, userId }) {
    try {
        let tenant = yield select(getTenant);
        const userRevision = yield call(getEventUser, api, tenant.tenantId, eventId, userId);
        yield put(actions.getEventUserSuccess(userRevision));
    } catch (error) {
        let errorObject = errorHandler(error, "Get", "event user details");
        yield put(actions.getEventUserFailure(errorObject));
    }
}

export function* watchGetEventUserRequest(api, { params }) {
    yield call(getEventUserRequest, api, params);
}

export default function* ({ api }) {
    yield takeLatest(actions.GET_EVENT_USER_REQUEST, watchGetEventUserRequest, api);
}